import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../../Services/Basequerywithreauth";

export const forwarderService = createApi({
  reducerPath: "forwarderService",
  baseQuery: createBaseQueryWithReauth(),
  endpoints: (builder) => ({
    getCargoDamageForwarders: builder.query({
      query: (params) => ({
        url: "trip-management/get-all-slot-bookings",
        params,
      }),
    }),
    getDoorList: builder.query({
      query: (params) => ({
        url: "door/list",
        params,
      }),
    }),
    getTripView: builder.query({
      query: (params) => ({
        url: "handler-trip-view-list",
        params,
      }),
    }),
    getNotification: builder.query({
      query: (params) => ({
        url: 'notification/user-notification-list',
        method: "POST",
        body: params,
      }),
    }),
    toggleSlotStatus: builder.mutation({
      query: (payload) => ({
        url: "trip-management/toggle-slot-status",
        method: "POST",
        body: payload,
      }),
    }),
    shiftReport: builder.query({
      query: (params) => ({
        url: "shift-report/get-reports",
        params,
      }),
    }),
    shiftAsset: builder.query({
      query: (params) => ({
        url: "shift-report/get-assets",
        params,
      }),
    }),
    shiftGroups: builder.query({
      query: (params) => ({
        url: "shift-report/get-groups",
        params,
      }),
    }),
    truckOrders: builder.query({
      query: (params) => ({
        url: "airline-order-view-list?tab_name=All&activity_status=A",
        params,
      }),
    }),
    truckOrderDetails: builder.query({
      query: (params) => ({
        url: "airline-order-view-details",
        params,
      }),
    }),
    truckOrderShipment: builder.query({
      query: (params) => ({
        url: "airline-truck-awbs",
        params,
      }),
    }),
    ARDriver: builder.query({
      query: (params) => ({
        url: "vehicle-management/list-drivers",
        params,
      }),
    }),
    ARVisitor: builder.query({
      query: (params) => ({
        url: "vehicle-management/list-visitors",
        params,
      }),
    }),
    getOrganizationSystemList: builder.query({
      query: (params) => ({
        url: "vehicle-management/get-organization-system-list",
        params,
      }),
    }),
    getShipmentList: builder.query({ 
      query: (params) => ({ 
        url: `trip-management/slots-fsu-manifest`, 
        params, 
      }), 
    }),
    getInboundFlightList: builder.query({ 
      query: (params) => ({ 
        url: `inbound-flights/flight-index`, 
        params, 
      }), 
    }),
    getInboundShipmentList: builder.query({
      query: (params) => ({
        url: `inbound-flights/shipment-index`,
        params,
      }),
    }),
    getWareHouseList: builder.query({
      query: (params) => ({
        url: `warehouse-list`,
        params,
      }),
    }),
    getDiscrepancyList: builder.query({
    query: ({ truckId, tab, pagenum, pagesize, recordstartindex, recordendindex, ...rest }) => ({
      url: `discrepancy/list/${truckId}`,   // path param
      params: { tab, pagenum, pagesize, recordstartindex, recordendindex, ...rest },
    }),
  }),
  }),
});

export const {
  useGetCargoDamageForwardersQuery,
  useGetDoorListQuery,
  useGetTripViewQuery,
  useGetNotificationQuery,
  useToggleSlotStatusMutation,
  useShiftReportQuery,
  useShiftAssetQuery,
  useShiftGroupsQuery,
  useTruckOrdersQuery,
  useTruckOrderDetailsQuery,
  useTruckOrderShipmentQuery,
  useARDriverQuery,
  useARVisitorQuery,
  useGetOrganizationSystemListQuery, 
  useGetShipmentListQuery,
  useGetInboundFlightListQuery,
  useGetInboundShipmentListQuery,
  useGetWareHouseListQuery,
  useGetDiscrepancyListQuery
} = forwarderService;
